'use strict';
import BasePickerController from './mx-picker-base-controller';

export default class SelectCtrl extends BasePickerController {
	constructor($timeout, $q, $element, $scope, i18n) {
		super($timeout, $q, $element, $scope, i18n);
		this.single = true;

		this._valuesShouldNotBeHiddenOnUI = [];
		this.setFirstSelected = true;

		Object.defineProperty(this, 'selectModel', {
			get: () => this.model,
			set: function (value) {
				this.setModelInternal(value);
				if (value !== undefined && value !== null && this._valuesShouldNotBeHiddenOnUI.indexOf(value) === -1) {
					this._valuesShouldNotBeHiddenOnUI.push(value);
				}
			},
		});

		$scope.$watch('vm.items', () => {
			this._optionsValueTitleMatching = {};
			(this.items || []).forEach((item) => {
				var title = this.getTitle(item);
				this._optionsValueTitleMatching[this.getId(item)] = title !== null && title !== undefined && typeof title.toString === 'function' ? title.toString() : title; // e.g. title === 0
			});
		});
	}

	$onInit() {
		super.$onInit();

		if (this.model !== undefined && this.model !== null) {
			this._valuesShouldNotBeHiddenOnUI.push(this.model);
		}

		const inputContainerEl = this.$element.find('> md-input-container');
		this.$element
			.find('select')
			.on('focus', () => {
				inputContainerEl.addClass('md-input-focused');
			})
			.on('blur', ($event) => {
				if (typeof this.onBlur === 'function') {
					this.onBlur($event);
				}
				inputContainerEl.removeClass('md-input-focused');
			});

		this.msgElemId = mx.components.Utils.genElemId('mx-aria-msg-');
	}

	$postLink() {
		this.setHintHandlers(this.$element.find('select'));
	}

	getTrackingValue(item) {
		return typeof item === 'object' ? this.getId(item) : item;
	}

	setSelectedItems(items) {
		this.selectModel = items.length ? this.getId(items[0]) : null;
	}

	selectedItemsToValue() {
		return this.model;
	}

	_filterHidden(item) {
		return !item.Hidden || this._valuesShouldNotBeHiddenOnUI.indexOf(this.getId(item)) !== -1;
	}

	_isItemHidden(itemValue) {
		return (this.items || []).some((arrItem) => arrItem.Hidden && this.getId(arrItem) === itemValue);
	}
}
SelectCtrl.$inject = ['$timeout', '$q', '$element', '$scope', 'mx.internationalization'];
